/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripsGeneratorCreateTrips: "trips-generator-create-trips",
} as const;
